import React from "react";
import styles from "./hero-section-v2.module.css"
import CTAButton from "../../../v2/common/CTA-Button/cta-button";

interface HeroSectionV2Props {
  backgroundImage: string; // e.g. "/images/home-hero.jpg"
  title: string;
  highlight: string;
  description: string;
}

const HeroSectionV2: React.FC<HeroSectionV2Props> = ({
                                                       backgroundImage,
                                                       title,
                                                       highlight,
                                                       description,
                                                     }) => {
  return (
      <section
          className={styles.hero}
          style={{
              backgroundImage: `url(${backgroundImage})`,
          }}
      >
        <div className={styles.heroContent}>
          <h1 className={styles.headline}>
            {title}
         </h1>
          <p className={styles.subHeadLine}>
             {description}
          </p>
            <div className={styles.buttons}>
                <a href="/contact" className={styles.btnPrimary}>
                    Get Started Today
                </a>
                {/*<a href="/about" className={styles.btnOutline}>*/}
                {/*    Learn More*/}
                {/*</a>*/}
            </div>
        </div>
      </section>
  );
};

export default HeroSectionV2;
